export const setCookie = (name: string): void => {
  const fourWeeks = new Date(Date.now() + 28 * 86400000);
  const formattedName = name.toLowerCase().replace(/\s+/g, '');
  document.cookie = `_acdotcom_feedback_${formattedName}=true; expires=${fourWeeks}`;
};
